import { render, staticRenderFns } from "./AddControllerTypeModal.vue?vue&type=template&id=701f16fa&"
import script from "./AddControllerTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddControllerTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports